var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-wrapper"},[_c('div',{class:{'checkbox': true, 'checked': _vm.checked},on:{"click":_vm.onClick}},[(_vm.checked)?_c('img',{staticClass:"checkmark",attrs:{"src":require('@/assets/icons/v-white.svg')}}):_vm._e()]),_vm._v(" "),_vm._t("title")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }